export const USER_DEFINED = 'USER_DEFINED';
export const HUBSPOT_DEFINED = 'HUBSPOT_DEFINED';
export const MODEL_INFERRED = 'MODEL_INFERRED';